<template>
  <el-select
    v-model="keyword"
    value-key="text"
    :placeholder="$t('keywordPlaceholder')"
    filterable
    size="medium"
    remote
    default-first-option
    :remote-method="searchKeywordsOptions"
    :loading="keywordsOptionsLoading"
  >
    <el-option
      v-for="keywordOption in keywordsOptions"
      :key="keywordOption.text"
      :label="keywordOption.text"
      :value="keywordOption"
    >
    </el-option>
  </el-select>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: [Array, String, Object],
  },
  data() {
    return {
      keywordsOptionsLoading: false,
      keywordsOptions: [],
      isLoadingContentOptimization: false,
    };
  },
  methods: {
    searchKeywordsOptions(query) {
      if (query != "") {
        this.keywordsOptionsLoading = true;
        let requestTrackedKeywordsSearch = {
          data: {
            attributes: {
              text: { rule: "CONTAINS", value: query }
            }
          }
        };
        this.$apiV2[this.studyLinks.searchTrackedKeywordsV2.method.toLowerCase()](
          this.studyLinks.searchTrackedKeywordsV2.href,
          requestTrackedKeywordsSearch
        )
          .then((responseTrackedKeywords) => {
            const uniqueKeywordsMap = new Map();

            let keywordsWithOptions = responseTrackedKeywords.data.data.attributes.keywords
            .map(keyword => ({text:keyword.keywordText ,...keyword }));

            keywordsWithOptions.forEach(keyword => {
              uniqueKeywordsMap.set(keyword.text, keyword);
            });

            const lowerQuery = query.toLowerCase();
            this.keywordsOptions = Array.from(uniqueKeywordsMap.values()).sort((a, b) => {
              const aIndex = a.text.toLowerCase().indexOf(lowerQuery);
              const bIndex = b.text.toLowerCase().indexOf(lowerQuery);
              if (aIndex !== bIndex) return aIndex - bIndex;
              return a.text.localeCompare(b.text);
            });
            this.keywordsOptionsLoading = false;
          })
          .catch((error) => {
            this.keywordsOptionsLoading = false;
            console.log(error);
          });
      }
    },
  },
  computed: {
    keyword: {
      get() {
        this.keywordsOptions = [this.value];
        return this.value;
      },
      set(keyword) {
        this.$emit("selectedStudyKeyword", keyword);
        this.$emit("input", keyword);
      },
    },
    ...mapState(["study", "studyLinks"]),
  },
  mounted() {
    this.$emit("selectedStudyKeyword", this.keyword);
  },
};
</script>

<i18n>
{
  "en": {
    "keywordPlaceholder": "Select a keyword",
    "failTofetchContentOptimization": "We encountered an error while fetching SERP metrics"
  },
  "fr": {
    "keywordPlaceholder": "Sélectionner un mot clé",
    "failTofetchContentOptimization": "Nous avons rencontré une erreur lors du chargement des données de la SERP"
  },
  "de": {
    "keywordPlaceholder": "Wählen Sie ein Schlüsselwort aus",
    "failTofetchContentOptimization": "Beim Laden von Daten aus dem SERP ist ein Fehler aufgetreten"
  }
}
</i18n>
